export default __webpack_public_path__ + "static/media/testImg.367c451f.svg";